import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Support',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      firstBoot: true,
      support: {
        additionalCost: 0,
        comment: '',
        dt: moment(new Date()).format(),
        id: 0,
        logDescription: '',
        logValue: 0,
        name: '',
        rateHr: 0,
        supportService: '',
        supportServiceId: 0,
        supportServiceType: '',
        supportServiceTypeId: 0,
        totalCost: 0,
        travelDistance: 0,
        travelDuration: 0,
        workDuration: 0
      },
      showSupportServicesRates: false,
      supportServicesAll: [],
      supportServices: [],
      supportService: { text: '', value: '' },
      supportServiceTypes: [],
      supportServiceType: { text: '', value: '' },
      allTeams: [],
      team: { text: '', value: '' },
      teamId: -1,
      stations: [],
      station: { text: '', value: '' },
      stationId: -1,
      selection: [],
      rateKey: 0,
    }
  },
  validations: {
    supportService: {
      required
    },
    supportServiceType: {
      required
    },
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    teams: function () {
      if (this.dataObj.stationId <= 0)
        return this.allTeams;
      else
        return this.allTeams.filter(t => t.group && t.group.id == this.dataObj.stationId);
    },
  },
  watch: {
    selectionCount: function (value) {
      this.dataObj.selection = [];
      if (value === 0)
        return;
      this.selection.forEach(p => {
        var item = {
          id: p.id,
          rate: p.rateHr
        };
        this.dataObj.selection.push(item);
      });
      this.calculateCost();
    },
    team: function (value) {
      if (!value)
        return;
      this.teamId = parseInt(value.value);
      this.filterSupportServices();
    },
    station: function (value) {
      if (!value)
        return;
      this.dataObj.stationId = value.value;
      this.stationId = parseInt(value.value);

      this.filterSupportServices();
    },
    supportServiceType: function (value) {
      if (!value)
        return;
      this.dataObj.supportServiceTypeId = value.value;
      this.filterSupportServices();
    },
    supportService: function (value) {
      if (!value)
        return;

      if (this.firstBoot) {
        this.firstBoot = false;
        return;
      }
      //console.log("sup serv rate", value.rateHr);
      this.support.rateHr = value.rateHr;
      this.dataObj.supportServiceId = value.id;
      this.dataObj.supportService = value.name;
      this.dataObj.supportServiceTypeId = value.supportServiceTypeId;
      this.dataObj.supportServiceType = value.supportServiceType;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.isMultiple = false;
        this.support = this.dataObj;
        this.support.showSupportServicesRates = this.dataObj.showSupportServicesRates;
        this.supportServicesAll = this.dataObj.supportServices;
        this.supportServices = this.supportServicesAll.filter(p => p.supportServiceTypeId === this.support.supportServiceTypeId.toString());
        if (this.supportServicesAll && this.supportServicesAll.length > 0)
          this.supportService = this.supportServicesAll.filter(p => p.id == this.dataObj.supportServiceId)[0];

        this.supportServiceTypes = this.dataObj.supportServiceTypes;
        this.dataObj.supportServiceTypeId = this.dataObj.supportServiceTypeId.toString();
        if (this.supportServiceTypes && this.supportServiceTypes.length > 0)
          this.supportServiceType = this.supportServiceTypes.filter(p => p.value == this.dataObj.supportServiceTypeId)[0];

        this.allTeams = this.dataObj.teams;
        this.stations = this.dataObj.stations;

        this.filterSupportServices();

        if (this.dataObj.rateHr == null || this.dataObj.rateHr == 0)
          this.firstBoot = false;
        else
          this.support.rateHr = this.dataObj.rateHr;

        
        console.log("sup", this.support);

        if (this.dataObj.stationId > 0) {
          let temp = this.stations.filter(s => s.value == this.dataObj.stationId);
          if (temp && temp.length > 0)
            this.station = temp[0];
        }
      });
    },
    calculateCost() {
      let total = 0;
      if (parseInt(this.support.workDuration) < 0 || isNaN(parseInt(this.support.workDuration))) {
        this.support.workDuration = 0;
        return;
      }
      if (parseInt(this.support.travelDuration) < 0 || isNaN(parseInt(this.support.travelDuration))) {
        this.support.travelDuration = 0;
        return;
      }
      if (parseInt(this.support.travelDistance) < 0 || isNaN(parseInt(this.support.travelDistance))) {
        this.support.travelDistance = 0;
        return;
      }
      if (this.dataObj.isMultiple === true) {
        this.selection.forEach(p => {
          total = total + (this.support.workDuration * parseFloat(p.rateHr) / 60 + this.support.travelDuration * parseFloat(p.rateHr) / 60)
        });
        this.dataObj.selection = [];
        this.selection.forEach(p => this.dataObj.selection.push({ id: p.id, rate: p.rateHr }));
      }
      else {
        total = this.support.workDuration * this.support.rateHr / 60 + this.support.travelDuration * this.support.rateHr / 60;
      }
      
      this.support.totalCost = total.toFixed(2);
    },
    setSelectedSupportService(value) {
      this.support.supportService = this.supportServices.filter(p => p.id === value)[0].name;
    },
    setSelectedServiceType(value) {
      this.support.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0].text;
      this.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0];
      this.filterSupportServices();
    },
    setSelectedTeam(value) {
      this.filterSupportServices();
    },
    setSelectedStation(value) {
      this.filterSupportServices();
    },
    filterSupportServices() {
      this.supportServices = this.supportServicesAll;
      if (this.teamId > -1)
        this.supportServices = this.supportServices.filter(p => p.teamId === this.teamId);
      if (this.stationId > -1)
        this.supportServices = this.supportServices.filter(p => p.stationId === this.stationId);
      if (this.support.supportServiceTypeId > 0)
        this.supportServices = this.supportServices.filter(p => p.supportServiceTypeId === parseInt(this.support.supportServiceTypeId));
    }
  },
}

